import type { NotificationFilters } from "./types";

export const NOTIFICATIONS_ENDPOINT = "/api/v2/Notifications";

export const NOTIFICATION_PAGE_SIZE = 20;

export const NOTIFICATION_STALE_TIME_MS = 60 * 1000;

export const NOTIFICATION_FILTER_OPTIONS_STALE_TIME_MS = 5 * 60 * 1000;

export const NOTIFICATION_FILTER_PARAMS = {
  SEVERITY: "severity",
  ACTOR_ID: "actorId",
  CLIENT_ID: "clientId",
  STATUS: "status",
  CREATED_AT_OR_BEFORE: "createdAtOrBefore",
} as const;

export const NOTIFICATION_DETAIL_PARAM = "notificationId";

export const NOTIFICATION_DEFAULT_WINDOW_DAYS = 30;

export const NOTIFICATION_ACTIONS = {
  READ: "read",
  UNREAD: "unread",
  ARCHIVE: "archive",
  UNARCHIVE: "unarchive",
} as const;

export type NotificationAction = (typeof NOTIFICATION_ACTIONS)[keyof typeof NOTIFICATION_ACTIONS];

export const READ_TOGGLE_ACTIONS: ReadonlySet<NotificationAction> = new Set([
  NOTIFICATION_ACTIONS.READ,
  NOTIFICATION_ACTIONS.UNREAD,
]);

export const NOTIFICATION_BULK_MAX_IDS = 1000;

export const NOTIFICATION_REJECTION_CODES: ReadonlySet<string> = new Set([
  "Validation.SelectionRequired",
  "Validation.ContradictoryStatus",
  "Validation.AmbiguousSelection",
  "Validation.InvalidExcludedNotificationIds",
]);

export const BELL_FILTERS: NotificationFilters = {
  status: "unread",
  severities: [],
  actorIds: [],
  clientIds: [],
};

export type NotificationsRoute = "Filters" | "Settings";

export const notificationsUrl = (route: NotificationsRoute) => `${NOTIFICATIONS_ENDPOINT}/${route}`;
